import React, { useState } from 'react';
import RecentOrderCard from 'components/logistics/user-profile-cards/recent-order-cards';
import UserDetailDashboard from 'components/logistics/user-profile-cards/user-detail-dashboard';
import UserProfileGeneralInfo from './user-profile-general-info';
import {
  DateRangeType,
  ENUM_DATE_RANGE,
  BaseModal,
  getDateRangeSelector
} from '@cokitchen/cokitchen-components';
type EditPartnerDetailsProps = {
  show: boolean;
  closeModal: () => void;
  user: any;
};
const UserProfileSideModal = ({ show, closeModal, user }: EditPartnerDetailsProps) => {
  const [dateRange, setDateRange] = useState<DateRangeType>({
    range: ENUM_DATE_RANGE.THIS_WEEK,
    date: getDateRangeSelector(ENUM_DATE_RANGE.THIS_WEEK)
  });

  return (
    <BaseModal position='right' isOpen={show} onRequestClose={closeModal} size='wide' title=''>
      <UserDetailDashboard user={user} dateRange={dateRange} onChange={setDateRange} />
      <UserProfileGeneralInfo user={user} />
      <p className='font-medium text-xl pb-4 pt-6'>Recent Orders</p>
      <RecentOrderCard user={user} dateRange={dateRange} />
    </BaseModal>
  );
};

export default UserProfileSideModal;
